export default __webpack_public_path__ + "staticlp3/media/advantages-devices.3d6b5019.png";